/* CS — Produto Travis · Culture Supply
   Lê a config JSON (script[data-cs-travis-config]) injetada pela secção. */
(function () {
  'use strict';

  function initCsTravis(cfgEl) {
    if (cfgEl.dataset.csDone === '1') return;
    cfgEl.dataset.csDone = '1';

    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

    var root = document.getElementById('cs-travis-' + cfg.sectionId);
    if (!root || root.dataset.csInit === '1') return;
    root.dataset.csInit = '1';

    var VARIANTS = cfg.variants || [];
    var fmt = new Intl.NumberFormat('pt-PT', { style: 'currency', currency: cfg.currency || 'EUR' });
    function money(cents) { return fmt.format(cents / 100); }

    try { csDecorate(root, cfg); } catch (e) {}

    /* ---------- Galeria ---------- */
    var slider = root.querySelector('[data-cs-slider]');
    var thumbs = root.querySelectorAll('.cs-travis-thumb');
    var dots = root.querySelectorAll('.cs-travis-dot');
    function goTo(i) { if (slider) slider.scrollTo({ left: i * slider.clientWidth, behavior: 'smooth' }); }
    function markActive(i) {
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(parseInt(t.dataset.index, 10)); }); });
    var prevBtn = root.querySelector('[data-cs-prev]');
    var nextBtn = root.querySelector('[data-cs-next]');
    function currentIndex() { return slider ? Math.round(slider.scrollLeft / slider.clientWidth) : 0; }
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(Math.max(0, currentIndex() - 1)); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(currentIndex() + 1); });
    if (slider) {
      var st;
      slider.addEventListener('scroll', function () {
        clearTimeout(st);
        st = setTimeout(function () { markActive(currentIndex()); }, 80);
      }, { passive: true });
    }

    /* ---------- Variantes ---------- */
    var pickers = root.querySelectorAll('.cs-travis-opt');
    var hiddenId = root.querySelector('[data-cs-variant-id]');
    var priceEls = root.querySelectorAll('[data-cs-price]');
    var compareEl = root.querySelector('[data-cs-compare]');
    var offEl = root.querySelector('[data-cs-off]');
    var atcBtn = root.querySelector('[data-cs-atc]');
    var atcLabel = root.querySelector('[data-cs-atc-label]');
    var stockEl = root.querySelector('[data-cs-stock]');
    var stickySelect = root.querySelector('[data-cs-sticky-select]');
    var stickyAtc = root.querySelector('[data-cs-sticky-atc]');
    var atcText = 'Adicionar ao carrinho';
    if (atcLabel && atcLabel.textContent.trim() && atcLabel.textContent.trim() !== 'Esgotado') {
      atcText = atcLabel.textContent.trim();
    }

    function selectedOptions() {
      var out = [];
      pickers.forEach(function (fs) {
        var checked = fs.querySelector('input:checked');
        out[parseInt(fs.dataset.optionIndex, 10)] = checked ? checked.value : null;
      });
      return out;
    }
    function findVariant(opts) {
      return VARIANTS.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      }) || null;
    }
    function currentMainVariant() {
      if (hiddenId) {
        var v = VARIANTS.find(function (x) { return String(x.id) === String(hiddenId.value); });
        if (v) return v;
      }
      return VARIANTS[0] || null;
    }
    function applyVariant(v) {
      if (!v) return;
      if (hiddenId) hiddenId.value = v.id;
      priceEls.forEach(function (el) { el.textContent = money(v.price); });
      var onSale = v.compare && v.compare > v.price;
      if (compareEl) { compareEl.hidden = !onSale; if (onSale) compareEl.textContent = money(v.compare); }
      if (offEl) { offEl.hidden = !onSale; if (onSale) offEl.textContent = '-' + Math.round((v.compare - v.price) * 100 / v.compare) + '%'; }
      if (atcBtn) {
        atcBtn.disabled = !v.available;
        if (atcLabel) atcLabel.textContent = v.available ? atcText : 'Esgotado';
      }
      if (stickyAtc) stickyAtc.disabled = !v.available;
      if (stickySelect && stickySelect.value !== String(v.id)) stickySelect.value = String(v.id);
      if (stockEl) {
        var th = parseInt(stockEl.dataset.threshold, 10) || 5;
        var show = v.managed && v.qty > 0 && v.qty <= th;
        stockEl.hidden = !show;
        var q = stockEl.querySelector('[data-cs-stock-qty]');
        if (q && show) q.textContent = v.qty;
      }
      if (v.mpos > 0) goTo(v.mpos - 1);
      pickers.forEach(function (fs) {
        var lbl = fs.querySelector('[data-cs-opt-value]');
        var checked = fs.querySelector('input:checked');
        if (lbl && checked) lbl.textContent = checked.value;
      });
      recomputeBundle();
    }
    pickers.forEach(function (fs) {
      fs.addEventListener('change', function () { applyVariant(findVariant(selectedOptions())); });
    });
    if (stickySelect) {
      stickySelect.addEventListener('change', function () {
        var v = VARIANTS.find(function (x) { return String(x.id) === stickySelect.value; });
        if (!v) return;
        v.options.forEach(function (val, i) {
          var fs = root.querySelector('.cs-travis-opt[data-option-index="' + i + '"]');
          if (!fs) return;
          var input = Array.prototype.find.call(fs.querySelectorAll('input'), function (inp) { return inp.value === val; });
          if (input) input.checked = true;
        });
        applyVariant(v);
      });
    }

    /* ---------- Carrinho ---------- */
    var toast = root.querySelector('[data-cs-toast]');
    var toastMsg = root.querySelector('[data-cs-toast-msg]');
    var toastTimer;
    function showToast(msg, isError) {
      if (!toast) return;
      toastMsg.textContent = msg;
      toast.classList.toggle('is-error', !!isError);
      toast.hidden = false;
      requestAnimationFrame(function () { toast.classList.add('is-visible'); });
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () {
        toast.classList.remove('is-visible');
        setTimeout(function () { toast.hidden = true; }, 250);
      }, 3500);
    }
    function refreshCartCount() {
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        document.querySelectorAll('[data-cart-count], .cart-count-bubble span[aria-hidden], .cart-count').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        window.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      }).catch(function () {});
    }
    function addItems(items, btn, successMsg) {
      if (!items.length) return;
      if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        return r.json().then(function (data) { return { ok: r.ok, data: data }; });
      }).then(function (res) {
        if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; }
        if (!res.ok) { showToast((res.data && res.data.description) || 'Não foi possível adicionar.', true); return; }
        refreshCartCount();
        if (root.dataset.afterAdd === 'cart') { window.location.href = cfg.cartUrl || '/cart'; return; }
        showToast(successMsg || '✓ Adicionado ao carrinho');
      }).catch(function () {
        if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; }
        showToast('Erro de ligação. Tenta novamente.', true);
      });
    }
    function addToCart(variantId, btn) { addItems([{ id: parseInt(variantId, 10), quantity: 1 }], btn); }

    var form = root.querySelector('.cs-travis-form');
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      addToCart(hiddenId.value, atcBtn);
    });
    if (stickyAtc) stickyAtc.addEventListener('click', function () {
      addToCart(hiddenId ? hiddenId.value : (VARIANTS[0] && VARIANTS[0].id), stickyAtc);
    });

    /* ---------- Combo / bundle ---------- */
    var bundle = root.querySelector('[data-cs-bundle]');
    function bundleAddonPrice(item) {
      var sel = item.querySelector('[data-cs-bundle-select]');
      if (sel) {
        var opt = sel.options[sel.selectedIndex];
        return { id: sel.value, price: parseInt(opt.getAttribute('data-price'), 10) || 0 };
      }
      var t = item.querySelector('[data-cs-bundle-toggle]');
      return { id: t ? t.getAttribute('data-vid') : null, price: t ? (parseInt(t.getAttribute('data-price'), 10) || 0) : 0 };
    }
    function recomputeBundle() {
      if (!bundle) return;
      var total = 0;
      var mv = currentMainVariant();
      if (mv) total += mv.price;
      var mainPriceEl = bundle.querySelector('[data-cs-bundle-main-price]');
      if (mainPriceEl && mv) mainPriceEl.textContent = money(mv.price);
      bundle.querySelectorAll('[data-cs-bundle-item]').forEach(function (item) {
        var toggle = item.querySelector('[data-cs-bundle-toggle]');
        if (!toggle || !toggle.checked) return;
        total += bundleAddonPrice(item).price;
      });
      var totalEl = bundle.querySelector('[data-cs-bundle-total-val]');
      if (totalEl) totalEl.textContent = money(total);
    }
    if (bundle) {
      bundle.addEventListener('change', function (e) {
        if (e.target.closest('[data-cs-bundle-toggle], [data-cs-bundle-select]')) recomputeBundle();
      });
      var bundleAdd = bundle.querySelector('[data-cs-bundle-add]');
      if (bundleAdd) bundleAdd.addEventListener('click', function () {
        var items = [];
        var mv = currentMainVariant();
        if (mv && mv.available) items.push({ id: parseInt(mv.id, 10), quantity: 1 });
        bundle.querySelectorAll('[data-cs-bundle-item]').forEach(function (item) {
          var toggle = item.querySelector('[data-cs-bundle-toggle]');
          if (!toggle || !toggle.checked) return;
          var a = bundleAddonPrice(item);
          if (a.id) items.push({ id: parseInt(a.id, 10), quantity: 1 });
        });
        if (!items.length) { showToast('Escolhe pelo menos um artigo.', true); return; }
        addItems(items, bundleAdd, '✓ Combo adicionado ao carrinho');
      });
      recomputeBundle();
    }

    /* ---------- Quick add (upsell + relacionados) ---------- */
    root.addEventListener('click', function (e) {
      var qa = e.target.closest('[data-cs-qa]');
      if (qa) {
        if (qa.dataset.vid) { addToCart(qa.dataset.vid, qa); }
        else if (qa.dataset.tray) {
          var tray = document.getElementById(qa.dataset.tray);
          if (tray) tray.hidden = !tray.hidden;
        }
        return;
      }
      var ts = e.target.closest('[data-cs-tray-add]');
      if (ts) {
        addToCart(ts.dataset.vid, ts);
        var parentTray = ts.closest('.cs-travis-tray');
        if (parentTray) parentTray.hidden = true;
      }
    });

    /* ---------- Barra fixa (mobile) ---------- */
    var sticky = root.querySelector('[data-cs-sticky]');
    if (sticky && atcBtn && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var en = entries[0];
        /* Só aparece depois de o utilizador passar o botão principal (botão acima do ecrã) */
        var passed = !en.isIntersecting && en.boundingClientRect.top < 60;
        sticky.classList.toggle('is-visible', passed);
        sticky.setAttribute('aria-hidden', passed ? 'false' : 'true');
      }, { rootMargin: '-60px 0px 0px 0px' });
      io.observe(atcBtn);
    }

    /* ---------- Guia de tamanhos (modal movido para o body) ---------- */
    var modal = document.getElementById('cs-travis-modal-' + cfg.sectionId);
    if (modal) {
      Array.prototype.slice.call(document.body.children).forEach(function (c) {
        if (c.id === 'cs-travis-modal-' + cfg.sectionId && c !== modal) c.remove();
      });
      document.body.appendChild(modal);
      function openModal() { modal.hidden = false; document.body.style.overflow = 'hidden'; }
      function closeModal() { modal.hidden = true; document.body.style.overflow = ''; }
      root.querySelectorAll('[data-cs-guide-open]').forEach(function (b) { b.addEventListener('click', openModal); });
      modal.querySelectorAll('[data-cs-guide-close]').forEach(function (b) { b.addEventListener('click', closeModal); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !modal.hidden) closeModal();
      });
    }
  }

  /* ---------- Camada visual: ticker, reveals, count-up ---------- */
  function csDecorate(root, cfg) {
    if (root.dataset.csDecor === '1') return;
    root.dataset.csDecor = '1';
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* Ticker a correr no topo (texto editável via config) */
    if (!root.querySelector('.cs-travis-ticker')) {
      var raw = (cfg.ticker || '').trim();
      var items = raw ? raw.split(',').map(function (s) { return s.trim(); }).filter(Boolean)
                      : ['Edição Deserto', 'Culture Supply', 'Estilo Vintage', 'Envio 24/48h'];
      if (items.length) {
        var unit = '';
        items.forEach(function (t) { unit += '<b>\u2726</b>' + t; });
        unit += '<b>\u2726</b>';
        var half = '';
        for (var r = 0; r < 4; r++) half += unit;
        var ticker = document.createElement('div');
        ticker.className = 'cs-travis-ticker';
        ticker.setAttribute('aria-hidden', 'true');
        ticker.innerHTML = '<div class="cs-travis-ticker-track"><span>' + half + '</span><span>' + half + '</span></div>';
        root.insertBefore(ticker, root.firstChild);
      }
    }

    var gallery = root.querySelector('.cs-travis-gallery');

    /* Reveal no scroll */
    var targets = [];
    if (gallery) targets.push(gallery);
    Array.prototype.forEach.call(root.querySelectorAll('.cs-travis-info > *'), function (el) { targets.push(el); });
    var story = root.querySelector('.cs-travis-story'); if (story) targets.push(story);
    var related = root.querySelector('.cs-travis-related'); if (related) targets.push(related);

    if (reduce || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('cs-travis-reveal', 'is-in'); });
    } else {
      targets.forEach(function (el) { el.classList.add('cs-travis-reveal'); });
      var io = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var el = en.target;
          var d = parseInt(el.getAttribute('data-cs-d') || '0', 10);
          el.style.transitionDelay = (d * 55) + 'ms';
          el.classList.add('is-in');
          obs.unobserve(el);
          setTimeout(function () { el.style.transitionDelay = ''; }, 700 + d * 55);
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' });
      var di = 0;
      targets.forEach(function (el) {
        if (el.parentNode && el.parentNode.classList && el.parentNode.classList.contains('cs-travis-info')) {
          el.setAttribute('data-cs-d', String(Math.min(di, 9))); di++;
        }
        io.observe(el);
      });
    }

    /* Count-up subtil do preço quando entra no ecrã */
    if (!reduce && 'IntersectionObserver' in window) {
      var priceEl = root.querySelector('.cs-travis-price');
      var hid = root.querySelector('[data-cs-variant-id]');
      var target = null;
      if (hid) {
        var vv = (cfg.variants || []).find(function (x) { return String(x.id) === String(hid.value); });
        if (vv) target = vv.price;
      }
      if (priceEl && target != null) {
        var fmtp = new Intl.NumberFormat('pt-PT', { style: 'currency', currency: cfg.currency || 'EUR' });
        var ran = false;
        var iop = new IntersectionObserver(function (entries, obs) {
          entries.forEach(function (en) {
            if (!en.isIntersecting || ran) return;
            ran = true; obs.disconnect();
            var start = null, dur = 620;
            (function frame(ts) {
              if (!start) start = ts;
              var p = Math.min((ts - start) / dur, 1);
              var e = 1 - Math.pow(1 - p, 3);
              priceEl.textContent = fmtp.format((target * e) / 100);
              if (p < 1) requestAnimationFrame(frame);
              else priceEl.textContent = fmtp.format(target / 100);
            })(performance.now());
          });
        }, { threshold: 0.6 });
        iop.observe(priceEl);
      }
    }
  }

  function scan(ctx) {
    var list = (ctx || document).querySelectorAll('script[data-cs-travis-config]');
    Array.prototype.forEach.call(list, initCsTravis);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
